RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.AccountStatus = window.createMarionetteApp();
    app.name = 'AccountStatus';

    app.addRegions({
        updateCardBtn: '.x-update-card'
    });

});
